import { IController, IScope, ITimeoutService, translate } from 'angular';
import { inject, injectable } from '../../../shared/utils/inject/inject';
import { ISlugify } from '../../services/filters/slugify/slugify.filter';
import { IHeightCalc } from '../../services/heightCalc/heightCalc.factory';
import { IMoment } from '../../services/moment/moment.factory';
import { IBiService } from '../../services/wix/biService';
import { ISettings, IWixBinding } from '../../services/wix/wixBinding';

@injectable
export class HorizontalRowController implements IController {
  public showDetails: boolean = false;
  public event: any;
  @inject private wixBinding: IWixBinding;
  @inject private heightCalc: IHeightCalc;
  @inject private $scope: IScope;
  @inject private $timeout: ITimeoutService;
  @inject private biService: IBiService;
  @inject private $translate: translate.ITranslateService;
  @inject private slugifyFilter: ISlugify;
  public formattedTimeAvailable: boolean;
  private settings: ISettings;
  public timeWithZone: undefined | { format(f: string): string };
  @inject private moment: IMoment;

  get hasOffers() {
    return this.event.offers && this.event.offers.length > 0;
  }

  get isVirtual() {
    return this.event.venue.type === 'Virtual';
  }

  $onInit(): void {
    this.settings = this.wixBinding.getSettings();

    if (this.isVirtual) {
      this.loadMoment();
    }
  }

  private loadMoment() {
    this.formattedTimeAvailable = false;
    this.moment.getMoment().then((moment) => {
      this.formattedTimeAvailable = true;
      this.timeWithZone = moment.tz(
        this.event.datetime,
        this.event.venue.timezone,
      );
    });
  }

  notifyMeBI() {
    this.biService.sendButtonEvent(this.settings.name, 'Notify Me');
  }

  rsvpBI() {
    this.biService.rsvp(this.settings.name);
  }

  openButtonUrl(offer) {
    if (offer.type === 'Tickets') {
      this.biService.tickets(this.settings.name);
      return;
    }

    this.biService.sendButtonEvent(this.settings.name, offer.type);
  }

  getUrl(part: string = '') {
    if (!this.event.url) {
      return;
    }
    return `${this.event.url}${part}`;
  }

  getOfferUrl(offer, part: string = '') {
    const url = offer.url || this.event.url;
    if (!url) {
      return;
    }
    return `${url}${part}`;
  }
}
